export default {
    miningWeeklyRewards: {
        title: '挖矿结算管理',
        detailTitle: '周期详情',
        empty: '暂无数据',
        back: '返回',
        period: {
            weekN: '周次',
            range: '周期',
            userCount: '用户数',
            recordCount: '记录数',
            actualOutput: '实际产出 (STORY)',
            scaled: 'Scaled',
            status: '状态',
            autoReleaseAt: '自动放行期限',
            approvedAt: '放行时间',
            overview: '周期概览',
        },
        status: {
            pending: '结算中',
            approved: '已放行',
        },
        columns: {
            userId: '用户 ID',
            rewardType: '奖励类型',
            weekN: '周次',
            nominalOutput: '名义产出',
            actualOutput: '实际产出',
            fromUserId: '来源用户 ID',
            auditStatus: '放行状态',
            auditBy: '放行人',
            auditRemark: '审核备注',
            auditAt: '放行时间',
            createdAt: '创建时间',
            action: '操作',
        },
        search: {
            userId: '用户 ID',
            rewardType: '奖励类型',
            auditStatus: '审核状态',
        },
        auditStatus: {
            pending: '未放行',
            audited: '已放行',
        },
        rewardType: {
            mining: '派遣收益',
            invite: '邀请收益',
        },
        actions: {
            viewDetail: '详情',
            release: '放行',
            released: '已放行',
            batchRelease: '批量放行',
            releasePeriod: '整周放行',
            export: '导出',
        },
        export: {
            success: '导出任务已提交，请到下载管理查看',
            missingWeek: '缺少周次信息',
        },
        audit: {
            approveTitle: '批量放行（{count} 条）',
            approvePeriodTitle: '确认放行周期',
            approvePeriodContent:
                '确认放行周期 {range} 的挖矿结算？放行后该周期内用户的收益将进入可领取状态。',
            selected: '已选 {count} 条',
            noSelection: '请先选择未放行记录',
            noPending: '当前周期没有未放行记录',
            auditByPlaceholder: '请输入审核人（可选）',
            auditRemarkPlaceholder: '请输入审核备注（可选）',
            memo: '备注',
            memoPlaceholder: '请输入备注（可选，将应用到所选记录）',
            rewardHint: '可在表格中修改未放行记录的实际产出；未改则按原始值放行',
        },
    },
};
